import React, { useState } from 'react'
import Header from './header'
import Footer from './footer'
import Sidebar from './sidebar'
import { motion, AnimatePresence } from 'framer-motion'
import CTABanner from './cta-banner'

interface Props {
  location: any
  children: JSX.Element | any
  className?: string
}

const Layout: React.FC<Props> = ({ location, children, className }): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false)
  const [activeMenu, setActiveMenu] = useState('')

  return (
    <>
      <div className={className}>
        <AnimatePresence mode='wait'>
          {isOpen && (
            <motion.div
              key='layout'
              className='bg-white fixed right-0 w-full h-full flex justify-end lg:hidden z-30'
              initial={{ opacity: 0, x: 1000 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 1000 }}
              transition={{ ease: 'easeOut', duration: 0.35 }}
            >
              <Sidebar
                key='sidebar'
                setIsOpen={setIsOpen}
                activeMenu={activeMenu}
                setActiveMenu={setActiveMenu}
              />
            </motion.div>
          )}
        </AnimatePresence>
        <Header
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          activeMenu={activeMenu}
          setActiveMenu={setActiveMenu}
        />

        <AnimatePresence mode='wait'>
          <main key='main' className='main'>
            {children}
          </main>
          <Footer key='footer' />
        </AnimatePresence>
      </div>
      {location && location.pathname !== '/request-demo/' ? <CTABanner /> : ''}
    </>
  )
}

export default Layout
